import React, {useState, useEffect} from "react";
import { CaptionTextTracks } from "./cms-data";
//import "./caption.css";
import CaptionState from './caption-state';

export type CaptionProps = {
  /**
   *  Data to load video
   */
  data: CaptionData;
  /**
   *  Events for the caption
   */
  events?: CaptionEvents;
  /**
   *  Additional options for caption to enable different interfaces like Model etc.
   */
  options?: CaptionOptions;
  /**
   *  Additional id passed to caption
   */
  testId?: string;
};

export type CaptionData = {
  controlsOpacity: any;
  currentTime: number;
  textTracks: CaptionTextTracks[];
};

export type CaptionOptions = {
  className?: string;
};

export type CaptionEvents = {};

export type CMSCaption  = {
  begin: number;
  end: number;
  text: string;
}

export const Caption = (props: CaptionProps, state:CaptionState) => {
    const [lastCaption, setLastCaption] = useState(null);
    const [captionState,setCaptionState] = useState(state);
    const [cssClasses, setCssClasses] = useState(["Caption__captions", "Caption__showing", "Caption__bottomGeneric", "font-regular","radius-sm", "scrim-dark",  props.data.controlsOpacity === 1 ? "Caption__addPadding" : '']);

    const updateCaption = () => {
        const currentTime = props.data.currentTime;
        const captions = props.data.textTracks;
        const captionsLength = captions && captions.length;
        for (let i = 0; i < captionsLength; i++) {
            if (captions[i].begin <= currentTime && captions[i].end >= currentTime) {
                setLastCaption(captions[i]);
            }
        }
    }

    useEffect(() => {
        updateCaption()
    })
    return(
        <>
            { lastCaption && lastCaption.begin <= props.data.currentTime &&
                 lastCaption.end >= props.data.currentTime ?
                  <div className={cssClasses.join(' ')}>
                      <div
                          className={"Caption__text font-regular color-white"}
                          dangerouslySetInnerHTML={{ __html: lastCaption && lastCaption.text }}
                      />
                  </div> : null
            } 
             {/*
              // @ts-ignore */}
              <style jsx global>{`
                .Caption__captions {
                    display: flex;
                    display: -ms-flexbox;
                    justify-content: center;
                    -ms-justify-content: center;
                    -ms-flex-pack: center;
                    box-sizing: content-box;
                    align-items: center;
                    overflow: hidden;
                    padding: 10px;
                    font-size: 1.2em;
                    line-height: normal;
                    text-align: center;
                    position: absolute;
                    left: 50%;
                    transform: translate(-50%, 0%);
                    transition: all 0.25s;
                  }
                  
                  .Caption__text {
                    border-radius: 3px;
                  }
                  
                  .Caption__showing {
                    max-height: 3em;
                  }
                  
                  .Caption__bottomGeneric {
                    bottom: 10px;
                  }
                  .Caption__bottomGeneric.Caption__addPadding {
                    bottom: 40px;
                  }
                  
                  @media screen and (max-width: 500px) {
                    .Caption__captions {
                      font-size: 0.8em;
                    }
                    .Caption__showing {
                      max-height: 4em;
                    }
                    .Caption__bottomModal {
                      bottom: 210px;
                    }
                  }
                  
                  @media screen and (min-width: 501px) and (max-width: 800px) {
                    .Caption__bottomModal {
                      bottom: 170px;
                    }
                  }                  
            `}</style>
        </>
    )
}

export default Caption;
